import React from 'react'
import { Segment, Header, Divider } from 'semantic-ui-react'
import Breadcrumb from 'components/Breadcrumb'
// import logo from 'assets/images/RDP.png'

export default function PageHeader() {
    return (
        <>
            <Segment.Group horizontal className='my-0 d-print-none' style={{ backgroundColor: '#e8e8e8' }}>
                {/* {!compact && <Segment className='py-0' style={{ flex: 'unset' }}>
                    <Image src={logo} size='tiny' />
                </Segment>} */}
                <Segment className='py-0' style={{ borderLeft: 'none' }}>
                    <Header size='large' content={<Breadcrumb />} style={{ color: '#002b56'  }} />
                </Segment>
            </Segment.Group>
            <Divider className='divider-header d-print-none' fitted />
        </>
    )
}
